import interpolateComponents from 'interpolate-components';
import { useContext } from 'react';
import { ADS_WILL_FINISH_COUNTDOWN } from 'src/common/constants/localizations/ads';
import { LocationAndLocalizationContext } from 'src/common/providers/LocationAndLocalizationProvider';
import { useStores } from 'src/common/stores';
import css from './videoAd.module.scss';

export default function VideoAdCountdown() {
  const { playerStore } = useStores();
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const elapsedSeconds = playerStore.currentTime() || 0;
  const duration = playerStore.duration() || 0;
  const nowPlaying = playerStore.metadata() || {};
  const timeRemaining = Math.floor(duration - elapsedSeconds);

  if (!timeRemaining) {
    return null;
  }

  return (
    <div className={css.countdownText}>
      {interpolateComponents({
        mixedString: getLocalizedText(ADS_WILL_FINISH_COUNTDOWN),
        components: {
          stationTitle: <span className={css.stationTitle}>{nowPlaying?.subtitle}</span>,
          timeRemaining: (
            <span className={css.timeRemaining}>
              {`00:${timeRemaining.toString().padStart(2, '0')}`}
            </span>
          ),
        },
      })}
    </div>
  );
}
